import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import { IconButton, Tooltip } from "@mui/material";

import { PLACEHOLDER_RUN_ID, RunGroup } from "./runGroups";
import { useRunEditor } from "./useRunEditor";
import { useRunHistory } from "./useRunHistory";

type Props = {
	group: RunGroup;
	editor: ReturnType<typeof useRunEditor>;
	history: ReturnType<typeof useRunHistory>;
	canEdit: boolean;
	isSaving: boolean;
};

export const RunActions = ({
	group,
	editor,
	history,
	canEdit,
	isSaving,
}: Props) => {
	const isViewingHistory = history.isViewing(group.runId);

	const historyButton = (
		<Tooltip title={isViewingHistory ? "Close history" : "Run history"} arrow>
			<span>
				<IconButton
					size="small"
					color={isViewingHistory ? "primary" : "default"}
					disabled={!editor.isIdle || group.runId === PLACEHOLDER_RUN_ID}
					onClick={() => history.toggle(group.runId)}
				>
					<HistoryIcon fontSize="small" />
				</IconButton>
			</span>
		</Tooltip>
	);

	if (!canEdit || isViewingHistory) return historyButton;

	if (!editor.isEditing(group.runId))
		return (
			<>
				{historyButton}
				<Tooltip title="Edit run" arrow>
					<span>
						<IconButton
							size="small"
							disabled={!editor.isIdle}
							onClick={() => editor.start(group)}
						>
							<EditIcon fontSize="small" />
						</IconButton>
					</span>
				</Tooltip>
			</>
		);

	return (
		<>
			<Tooltip title="Cancel" arrow>
				<span>
					<IconButton size="small" disabled={isSaving} onClick={editor.cancel}>
						<CloseIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title="Save" arrow>
				<span>
					<IconButton
						size="small"
						color="primary"
						disabled={isSaving || editor.hasInvalid}
						onClick={() => editor.save(group)}
					>
						<CheckIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
		</>
	);
};
